import React, { useState } from "react";
import { Col, Form, Input, message, notification, Row } from "antd";
import s from "./ChangePassword.module.scss";
import {
  CheckCircleOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  KeyOutlined,
  LoginOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login, resetPassword } from "../../redux/AuthSlice";
import { AppDispatch, RootState } from "../../redux/store";
import { useTranslation } from "react-i18next";
import LoginHeader from "../../components/Header/LoginHeader";
import MobileLoginHeader from "../../components/MobileHeader/MobileLoginHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import Header from "../LandingPage/components/Header/LandingHeader";

const ChangePassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [form] = useForm();
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const email = useSelector((state: RootState) => state.auth.email);
  const { t } = useTranslation();
  const { width } = useWindowDimensions();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const openNotification =
    (pauseOnHover: boolean, message: string, type: "success" | "error") =>
    () => {
      let icon;
      switch (type) {
        case "success":
          icon = <CheckCircleOutlined style={{ color: "green" }} />;
          break;

        case "error":
          icon = <WarningOutlined style={{ color: "red" }} />;
          break;
      }
      api.open({
        message,
        icon,
        showProgress: true,
        pauseOnHover,
      });
    };

  const resetForgottenPassword = async (values: { email: string }) => {
    try {
      const res = await dispatch(
        resetPassword({
          email: values.email,
        })
      );
      if (resetPassword.fulfilled.match(res)) {
        const message =
          res.payload && "message" in res.payload ? res.payload.message : "";

        openNotification(true, message, "success")();
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  return (
    <div>
      {width > 500 ? <Header /> : <MobileLoginHeader />}
      <div className={s.login}>
        {contextHolder}

        <h2 className={s.h2}>
          <KeyOutlined className={s.icon} />
          {t("Сбросить пароль")}
        </h2>
        <Form
          className={s.form}
          layout='vertical'
          form={form}
          onFinish={resetForgottenPassword}
        >
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name='email'
                label={t("Email")}
                rules={[
                  { required: true, message: t("Введите email") },
                  { type: "email", message: t("Укажите корректный email") },
                ]}
              >
                <input placeholder={t("Введите email")} className={s.input} />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <button className={s.enter_btn}>{t("Сбросить")}</button>
          </Row>
          <div className={s.no_account}>
            {t("Уже есть аккаунт?")} &nbsp;
            <Link to='/login' className={s.register_btn}>
              {t("Войти")}
            </Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ChangePassword;
